import React, { useEffect, useState } from 'react';
import { redirect, useNavigate } from 'react-router-dom';

import "./nefPaymentSuccess.css";
import GlobalLoader from '../../commanComponents/loaderCenter/loaderCenter';
import { clearData } from "../../../utils/localStorage";
import { getNeFestPaymentListService } from "../../../modules/services";
import BaseNavbar from '../../../components/commanComponents/navbar/baseNavbar';
import StickyHeadTable from '../../commanComponents/table/basicTable';


const NEFestPaymentSuccess = () => {
    const [dataMeta, setDataMeta] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    
    const getUserListData = (pageNo) => {
        (async () => {
            console.log({pagination: "true", page: pageNo})
            const responseData = await getNeFestPaymentListService({pagination: "true", page: pageNo});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setDataList([...dataList, ...responseData.data[0].results]);
                setDataMeta(responseData.data[0].links);
                setIsLoading(false);
            }
            else if (responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                window.location.href = 'https://fizrobotics.com';
            }
            else {
                clearData();
                window.location.href = 'https://fizrobotics.com';
            }
        })();
    }

    useEffect(() => {
        getUserListData(1);
    }, []);

    const handleLoadMore = () => { 
        if (dataMeta.next) {
            setIsLoading(true);
            getUserListData(dataMeta.current + 1);
        }
    }

    const tableColumns = [
        {
            id: 'serial_no',
            label: 'Serial No.',
            minWidth: 170
        },
        {
            id: 'student_name',
            label: 'Student Name',
            minWidth: 170
        },
        {
            id: 'guardian_name',
            label: 'Guardian Name',
            minWidth: 170,
        },
        {
            id: 'competition_id',
            label: 'Competition Id',
            minWidth: 170,
        },
        {
            id: 'phone',
            label: 'Phone no.',
            minWidth: 170,
        },
        {
            id: 'email',
            label: 'Email',
            minWidth: 170,
          },
        {
            id: 'school_name',
            label: 'School Name',
            minWidth: 170,
        },
        {
            id: 'student_class',
            label: 'Student Class',
            minWidth: 170,
        },
        {
            id: 'team_size',
            label: 'Team Size',
            minWidth: 170,
        },
        {
            id: 'team_category',
            label: 'Team Category',
            minWidth: 170,
        },
        {
            id: 'city',
            label: 'City',
            minWidth: 170,
        },
        {
            id: 'state',
            label: 'State',
            minWidth: 170,
        },
        {
            id: 'payment_id',
            label: 'Payment Id',
            minWidth: 170,
        },
        {
            id: 'created_at',
            label: 'Created At',
            minWidth: 170,
        },
        {
            id: 'amount',
            label: 'Amount',
            minWidth: 170,
        },
        {
            id: 'submission_verification',
            label: 'Submission First Step',
            minWidth: 170,
        },
        {
            id: 'submission_guardian_name',
            label: 'Submission guardian Name',
            minWidth: 170,
        },
        {
            id: 'submission_video_url',
            label: 'Submission video url',
            minWidth: 170,
        },
        {
            id: 'submission_project_pdf',
            label: 'Submission Project PDF URL',
            minWidth: 170,
        },
    ];

    const formatDate = (dateString) => {
        const options = { 
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        };
    
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const handleFilterTableData = (dataList) => { 
        var responseList = []
        dataList.map((data, index) => responseList.push([
            data.id,
            index + 1,
            data.student_name,
            data.guardian_name,
            data.competition_id,
            data.phone,
            data.email,
            data.school_name,
            data.student_class,
            data.team_size === 1 ? "1 Member Team" : "2 Members Team",
            data.team_category,
            data.city,
            data.state,
            data.payment_id,
            formatDate(data.created_at),
            data.amount * 0.01,
            data.submission_verification ? "Submitted" : "Not Submitted",
            data.submission_guardian_name ? data.submission_guardian_name : "None",
            data.submission_video_url ? <a href={data.submission_video_url}>Submission Link</a> : "None",
            data.submission_project_pdf ? <a href={data.submission_project_pdf}>Submission Link</a> : "None",
        ]))
        return responseList;
    } 

    return (
        <>
            <BaseNavbar />
            <h1 style={{textAlign: "center", margin: "20px"}}>N.E.F. 2.0 Students List</h1>
            <div className='school-list-main-container'>
                    <StickyHeadTable columns={tableColumns} dataList={dataList.length > 0 ? handleFilterTableData(dataList) : []} handleLoadMore={handleLoadMore} isPagination={true} />
                    {isLoading && <GlobalLoader />}
            </div>
        </>
    );
}

export default NEFestPaymentSuccess;
